<template>
  <a-modal
    title="编辑配置"
    :width="600"
    :visible="visible"
    v-if="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    :maskClosable="false"
  >
    <a-spin :spinning="confirmLoading || dataLoading">
      <div v-for="index in ['一','二', '三']" :key="index">
        <a-divider orientation="left">第{{ index }}条消息</a-divider>
        <MessageItem :show-time="index !== '一'" ref="messageItem"></MessageItem>
      </div>
      <a-divider orientation="left">消息配置</a-divider>
      <a-form :form="form">
        <a-form-item label="本次发送人数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['send_num', {initialValue: 50, rules: [{ required: true, message: '必填项' }] }]" />
        </a-form-item>
        <a-form-item label="用户发送时间间隔(秒)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['min_user_send', { initialValue: 20, rules: [{ required: true, message: '必填项' }] }]" />
          - <a-input-number v-decorator="['max_user_send', { initialValue: 60, rules: [{ required: true, message: '必填项' }] }]" />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" :disabled="dataLoading" type="primary" @click="handleSubmit">保存配置</a-button>
    </template>
  </a-modal>
</template>

<script>
import FansApi from '@/api/fans'
import SelectFansModal from '@/views/components/SelectFansModal'
import ProgramApi from '@/api/program'
import GrouppushApi from '@/api/grouppush'
import MessageItem from '@/views/grouppush/components/MessageItem'

const messageTypes = [
  { value: 1, label: '文本' },
  { value: 2, label: '图片' },
  { value: 3, label: '视频' },
  { value: 4, label: '动图' },
  { value: 5, label: '卡片' },
  { value: 6, label: '群邀请' },
  { value: 7, label: '名片' },
  { value: 8, label: '小程序/视频号' }
]

export default {
  components: {
    MessageItem,
    SelectFansModal
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      messageTypes,
      mdl: {},
      visible: false,
      confirmLoading: false,
      form: null,
      dataLoading: false,
      formData: {},
      currentRobotId: null,
      groups: [],
      previewPictureVisible: false,
      previewPictureImage: '',
      usercard: null,
      UploadToken: ''
    }
  },
  created() {
    this.form = this.$form.createForm(this, {
      onValuesChange: (_, values) => {
        Object.assign(this.formData, values)
      }
    })
  },
  methods: {
    show(robot_id) {
      this.currentRobotId = robot_id
      this.visible = true
      this.getData()
    },
    getGroups() {
      FansApi.getGroupList({
        sub_id: this.currentRobotId
      }).then((res) => {
        const list = res.data
        this.groups = list.map((item) => {
          return item.name
        })
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const promises = this.$refs.messageItem.map(v => v.validate())
          Promise.all(promises).then(arr => {
            const messages = arr.map(v => {
              if (v.content) {
                return {
                  type: v.type,
                  content: v.content,
                  timeout: v.timeout
                }
              }
            }).filter(v => !!v)
            if (messages.length === 0) {
              return this.$message.error('最少发送一条消息！')
            }
            this.confirmLoading = true
            GrouppushApi.addTask({
              messages,
              sub_id: this.currentRobotId,
              send_num: values.send_num,
              min_user_send: values.min_user_send,
              max_user_send: values.max_user_send,
              status: 0
            })
              .then((res) => {
                if (res.code === 1) {
                  this.$message.success('提交成功')
                  this.visible = false
                  this.$emit('ok')
                } else {
                  this.$message.error(res.msg)
                }
              })
              .finally(() => {
                this.confirmLoading = false
              })
          })
        }
      })
    },
    handlePictureCancel() {
      this.previewVisible = false
    },
    handlePicturePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e
      }
      return e && e.fileList
    },

    async getData() {
      if (!this.currentRobotId) return
      const { data } = await GrouppushApi.getTask({
        sub_id: this.currentRobotId
      })
      const { messages } = data
      // console.log(data)
      this.form.setFieldsValue({
        send_num: data.send_num,
        min_user_send: data.min_user_send,
        max_user_send: data.max_user_send
      })
      this.$refs.messageItem.forEach((v, i) => {
        const obj = messages[i]
        if (!obj) return

        setTimeout(() => {
          // console.log(v.form)
          if (obj.timeout || obj.timeout == 0) {
            v.form.setFieldsValue({ timeout: obj.timeout })
          }
          if (obj.type == '1') {
            v.form.setFieldsValue({
              type: obj.type,
              wenben: obj.content,
              keyword: obj.keyword,
              id: obj.id
            })
          } else if (obj.type == 2) {
            const qn = obj.content
            v.form.setFieldsValue({ type: obj.type })
            this.$nextTick().then(() => {
              v.form.setFieldsValue({
                tupian: [
                  {
                    uid: qn.fname,
                    name: qn.fname,
                    status: 'done',
                    type: 'image/png',
                    response: qn,
                    url: `http://${qn.domain}/${qn.fkey}`
                  }
                ]
              })
            })
          } else if (obj.type == 3) {
            const qn = obj.content
            v.form.setFieldsValue({ type: obj.type })
            this.$nextTick().then(() => {
              v.form.setFieldsValue({
                shipin: [
                  {
                    uid: qn.fname,
                    name: qn.fname,
                    status: 'done',
                    response: qn,
                    url: `http://${qn.domain}/${qn.fkey}`
                  }
                ]
              })
            })
          } else if (obj.type == 4) {
            const qn = obj.content
            v.form.setFieldsValue({ type: obj.type })
            this.$nextTick().then(() => {
              v.form.setFieldsValue({
                dongtu: [
                  {
                    uid: qn.fname,
                    name: qn.fname,
                    status: 'done',
                    response: qn,
                    url: `http://${qn.domain}/${qn.fkey}`
                  }
                ]
              })
            })
          } else if (obj.type == 5) {
            const qn = obj.content
            v.form.setFieldsValue({ type: obj.type })
            this.$nextTick().then(() => {
              v.form.setFieldsValue({
                kapianTitle: qn.title,
                kapianDesc: qn.des,
                kapianImg: qn.img,
                kapianUrl: qn.url
              })
            })
          } else if (obj.type == '6') {
            const qunData = obj.content
            v.form.setFieldsValue({
              type: obj.type
            })
            this.$nextTick().then(() => {
              v.form.setFieldsValue({
                qunId: qunData.qunId
              })
            })
          } else if (obj.type == '7') {
            v.form.setFieldsValue({
              type: obj.type
            })
            this.$nextTick().then(() => {
              v.form.setFieldsValue({
                wid: obj.content
              })
            })
          } else if (obj.type == '8') {
            v.form.setFieldsValue({
              type: obj.type
            })
            this.$nextTick().then(() => {
              v.form.setFieldsValue({
                content: obj.content
              })
            })
          }
        }, 500)
      })
    },

    onChangeFans(data) {
      let wwid = data.wwid
      wwid = wwid.replace(/-/g, 'p')
      wwid = wwid.replace(/\*/g, 'o')
      wwid = wwid.replace(/&/g, 'i')
      wwid = wwid.replace(/\^/g, 'u')
      this.usercard = {
        wxid: window.atob(wwid),
        nickname: data.nickname,
        avatar: data.avatar,
        uid: data.uid
      }
      this.$refs.selectFansModal.handleCancel()
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isLt25M = file.size / 1024 / 1024 < 25
        if (!isLt25M) {
          this.$message.error('由于微信限制，上传文件不能大于25M!')
          reject()
        }
        ProgramApi.getQiniuToken()
          .then((response) => {
            if (response.code === 1) {
              const token = response.data
              this.UploadToken = token
              setTimeout(() => {
                resolve()
              }, 100)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
</script>
